
import Vue from "vue"
import Preview from '@/components/preview/index.vue'
import Layout from './index.vue'
export default Vue.extend({
   components:{
	Preview,
	Layout
   }
})
